import { Badge, BadgeSize, Tooltip } from '@dixa/lib-shared-habla';

type AiAssistedBadgeProps = {
  size?: BadgeSize;
  className?: string;
  tooltip?: string;
};

/**
 * Marks an article, or a single version of an article, as having been written
 * with AI assistance.
 */
export function AiAssistedBadge({
  size = 'medium',
  className,
  tooltip = 'This article was written with AI assistance.',
}: AiAssistedBadgeProps): JSX.Element {
  return (
    <Tooltip content={tooltip}>
      <Badge variant="primary" size={size} className={className} icon="ai">
        AI-assisted
      </Badge>
    </Tooltip>
  );
}
